// extracted by mini-css-extract-plugin
export var currencyInput = "_mx-1";
export var currencySymbol = "_mx-0";